
// HACK FOR react-data-grid until they upgrade to react 16.*
import './react_data_grid_hacks/fix-create-class';
import './react_data_grid_hacks/fix-prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css';
// Temp fix for reactstrap
import './scss/core/_dropdown-menu-right.scss';
// Redux Store
import configureStore from './store';
// Root component
import Root from './containers/Root';
import registerServiceWorker from './registerServiceWorker';


import simpleNumberLocalizer from 'react-widgets-simple-number';
simpleNumberLocalizer();



let store = configureStore();
ReactDOM.render(( <Root store={store} /> ), document.getElementById('root'));


registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js